export default __webpack_public_path__ + "static/media/iran.dae7ec80.png";